<template>
  <section class="container">
    <b-tabs type="is-rounded" v-on:input="setCurrentTab">
      <b-tab-item :label="productType.name" v-for="productType of equipmentTypes" :key="productType.id">
        <template slot="header">
          <span> {{productType.name}} <b-tag rounded v-if="productType.products"> {{productType.products.length}}
            </b-tag> </span>
        </template>
        <div class="" style="margin:2% auto">
          <div class="columns">
            <div class="column is-full">

              <b-table :paginated="isPaginated" :per-page="perPage" :current-page.sync="currentPage"
                :pagination-simple="isPaginationSimple" :pagination-position="paginationPosition"
                v-if="productType.products" :data="isEmpty ? [] : productType.products" :bordered="true" :striped="true"
                :narrowed="true" :hoverable="true" :loading="isLoading" :focusable="true" :selected-sync="selected"
                :mobile-cards="true">

                <template slot-scope="props">
                  <b-table-column field="name" label="Name">
                    {{ props.row.name }} {{props.row.extra ? `(${props.row.extra})` : ''}}
                  </b-table-column>

                  <b-table-column field="quantity" label="Quantity">
                    {{props.row.quantity}}
                  </b-table-column>

                  <b-table-column field="ward" label="Ward">
                      {{ props.row.ward }}
                  </b-table-column>

                  <b-table-column field="district" label="District">
                      {{ props.row.district? props.row.district[0].districtName: ""}}
                  </b-table-column>

                  <b-table-column field="province" label="Province">
                      {{ props.row.province[0].provinceName }}
                  </b-table-column>

                  <b-table-column field="description" label="Description">
                      {{ props.row.equipmentType.description }}
                  </b-table-column>

                  <b-table-column field="action" label="Action" v-if="isProvincialManager">
                    <!-- <b-switch v-model="props.row.available" @input="setProductAvailability(props.row)" :true-value="'true'" :false-value="'false'">
                    </b-switch> -->
                    <b-tooltip label="Edit">
                      <button class="button is-primary " @click="openEditEquipmentModal(props.row)">
                        <b-icon icon="pencil" size="is-small">
                        </b-icon>
                      </button>
                    </b-tooltip>
                    <b-tooltip class=" is-danger " label="Delete">
                      <button class="button is-danger " @click="openDeleteEquipmentModal(props.row)">
                        <b-icon icon="delete" size="is-small">
                        </b-icon>
                      </button>
                    </b-tooltip>
                  </b-table-column>
                  <!-- <b-table-column field="id" label="Product ID">
                    {{ props.row.id }}
                  </b-table-column> -->
                </template>

                <template slot="empty" v-if="!isLoading && productType.products.length == 0">
                  <section class="section">
                    <div class="content has-text-grey has-text-centered">
                      <p>
                        <b-icon icon="emoticon-sad" size="is-large">
                        </b-icon>
                      </p>
                      <p>Nothing here.</p>
                    </div>
                  </section>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </b-tab-item>
    </b-tabs>
  </section>
</template>

<script>
  import decode from 'jwt-decode';
  import {ls} from '@/helpers'
  const EditEquipmentModal = () => import('@/components/Equipment/EditEquipmentModal');
  const DeleteEquipmentModal = () => import('@/components/Equipment/DeleteEquipmentModal');
  import {
    ucFirst
  } from '@/helpers';
  import {
    mapActions
  } from 'vuex';

  export default {
    name: "Products",
    data() {
      return {
        isPaginated: true,
        isPaginationSimple: false,
        paginationPosition: 'bottom',

        defaultSortDirection: 'asc',
        sortIcon: 'arrow-up',
        sortIconSize: 'is-small',
        currentPage: 1,
        perPage: 50,
        isLoading: false,
        selected: [],
        equipmentTypes: [],
        currentEquipmentType: ""
      }
    },
    computed: {
      isEmpty() {
        return this.isLoading == true && this.equipmentTypes.filter(pT => pT.id == this.currentEquipmentType)[0].products
          .length == 0;
      },
      isProvincialManager() {
        return decode(ls('token')).user.type == "provincial-manager";
      }
    },
    created() {
      this.getEquipmentTypes()
    },
    methods: {
      ...mapActions([
        'editProduct'
      ]),
      setCurrentTab(currentIndex) {
        console.log(this.equipmentTypes[currentIndex])
        this.currentEquipmentType = (this.equipmentTypes[currentIndex]) ? this.equipmentTypes[currentIndex].id : null;
        if (this.currentEquipmentType)
          this.getEquipmentByType(this.currentEquipmentType);
      },
      getEquipmentTypes() {
        const loading = this.$loading.open();
        this.$store.dispatch('getEquipmentTypes').then(({meta, equipmentTypes}) => {
          loading.close()
          if (equipmentTypes && equipmentTypes.length > 0) {
            this.equipmentTypes = equipmentTypes;
            this.currentEquipmentType = (equipmentTypes[0].id) ? equipmentTypes[0].id : null;
            this.getEquipmentByType(this.currentEquipmentType);
          } else {
            this.$toasted.global.error('Product types not found.');
          }
        }).catch(e => {
          loading.close()
          console.log('Exception when getting product types for Products tabs', e);
          this.$toasted.global.error('Failed to get product types.');
        })
      },
      getEquipmentByType(type) {
        const loading = this.$loading.open();
        this.$store.dispatch('getTypeEquipment', type).then(products => {
          loading.close();
          if (!products) products = [];
          this.equipmentTypes = this.equipmentTypes.map(productType => {
            if (productType && productType.id == type)
              productType.products = products;

            return productType;
          })
        }).catch(e => {
          this.equipmentTypes = this.equipmentTypes.filter(productType => productType.id != null).map(productType => {
            if (productType && productType.id == type)
              productType.products = [];

            return productType;
          })
          loading.close();
          this.$toasted.global.error(`Failed to get ${ucFirst(type)} products.`)
          console.log('Exception when getting', type, 'products', e);
        })
      },
      openEditEquipmentModal(equipment) {
        this.$modal.open({
          component: EditEquipmentModal,
          parent: this,
          props: {
            equipment
          },
          events: {
            closeModal: () => {
              this.getEquipmentByType(this.currentEquipmentType);
            }
          }
        })
      },
      openDeleteEquipmentModal(equipment) {
        this.$modal.open({
          component: DeleteEquipmentModal,
          parent: this,
          props: {
            equipment
          },
          events: {
            reload: () => {
              this.getEquipmentByType(this.currentEquipmentType);
            }
          }
        })
      },
      async setProductAvailability(product) {
        try {
          await this.editProduct({ id: product.id, available: product.available });
          this.$toasted.global.success(`Product ${product.available === "true" ? 'now Available!' : 'Nolonger available.'}.`);
        } catch (e) {
          this.getEquipmentByType(this.currentEquipmentType);
          console.log(`Exception when updating product availability, e: ${e}`);
          this.$toasted.global.error(`Failed to update product.`)
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Equipment/Equipment.vue